var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "ctm-entries-table",
          attrs: {
            data: _vm.paginatedData,
            stripe: "",
            "empty-text": "No entries found."
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "#", width: "64", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "post_title",
              label: "Form",
              "min-width": "160",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "User", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticClass: "ctm-user-cell" }, [
                      _c("i", { staticClass: "el-icon-user" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            scope.row.user_id > 0
                              ? "User #" + scope.row.user_id
                              : "Guest"
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Status", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        class:
                          "ctm-status ctm-status--" +
                          (scope.row.status || "publish")
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.statusLabel(scope.row.status)) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created_at", label: "Submitted", width: "190" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticClass: "ctm-date-cell" }, [
                      _c("i", { staticClass: "el-icon-time" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.created_at) +
                          "\n        "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "Actions", width: "155", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "ctm-actions" },
                      [
                        _vm.hasForm
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    _vm.admin_url +
                                    "?page=contactum-entries#/forms/" +
                                    _vm.form_id +
                                    "/entries/" +
                                    scope.row.id
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      icon: "el-icon-view"
                                    }
                                  },
                                  [_vm._v("View")]
                                )
                              ],
                              1
                            )
                          : _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "form-entry",
                                    params: {
                                      form_id: scope.row.form_id,
                                      entry_id: scope.row.id
                                    }
                                  }
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      icon: "el-icon-view"
                                    }
                                  },
                                  [_vm._v("View")]
                                )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            plain: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmDelete(scope.row)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }